import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedConstants } from '@app/eds';

@Component({
  selector: 'app-mobile-header[titleTextKey]',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent {
  // If true then show single text with menu icon
  @Input() showHamburger = true;

  // If true then show close icon
  @Input() showCloseIcon = true;

  // If true then show back icon
  @Input() showBackIcon = true;

  // Whether to show close icon in replacement of back icon
  @Input() showCloseIconInReplaceOfBackIcon = false;

  // Main text to display
  @Input() titleTextKey: string = SharedConstants.EMPTY_STRING;

  // Small upper text to display
  @Input() overlineText: string = SharedConstants.EMPTY_STRING;

  // If false show only title else show title subtile with hamberger
  @Input() showTitleSubTitleWithHamberger = false;

  // This Props will trigger event for close back icon component.
  @Output() backIconClicked: EventEmitter<Function> = new EventEmitter<Function>();

  // This Props will trigger event for close close icon component
  @Output() closeIconClicked: EventEmitter<Function> = new EventEmitter<Function>();

  // This Props will trigger event for menu icon component.
  @Output() menuIconClicked: EventEmitter<Function> = new EventEmitter<Function>();

  // Event emitter when close icon which was replacement of back icon is pressed
  @Output() closeBackIconClicked: EventEmitter<Function> = new EventEmitter<Function>();

  /**
   * This method is triggered when user clicks on back icon.
   */
  onBackIconClick = () => this.backIconClicked.emit();

  /**
   * This method is triggered when user clicks on close icon.
   */
  onCloseIconClick = () => this.closeIconClicked.emit();

  /**
   * This method is triggered when user clicks on close icon
   * of the area where back icon was present.
   */
  onCloseBackIconClick = () => this.closeBackIconClicked.emit();

  /**
   * This method is triggered when user clicks on menu icon.
   */
  onMenuIconClick = () => this.menuIconClicked.emit();
}
